import { createSlice } from '@reduxjs/toolkit';

const initialState = { totalUnread: 0 };

const inboxSlice = createSlice({
  name: 'inbox',
  initialState,
  reducers: {
    setTotalUnread: (state, action) => { state.totalUnread = action.payload; },
  },
  extraReducers: b => b.addCase('auth/logout', () => initialState),
});

export const { setTotalUnread } = inboxSlice.actions;
export default inboxSlice.reducer;
